'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _radium = require('radium');

var _radium2 = _interopRequireDefault(_radium);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styles = {
  wrapper: {
    position: 'fixed',
    zIndex: '2000',
    backgroundColor: 'rgba(0, 0, 0, 0.68)',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  },
  container: {
    backgroundColor: 'white',
    marginTop: '100px',
    marginLeft: 'auto',
    marginRight: 'auto',
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '30px 0 80px',
    flexDirection: 'column'
  },
  btn: {
    background: 'url(https://cdn-s3.touchofmodern.com/partners/assets/icon_close@2x.png) no-repeat',
    width: '100px',
    height: '100px',
    zoom: '25%',
    left: 'calc(100% - 100px)',
    top: '-120px',
    position: 'absolute',
    cursor: 'pointer'
  },
  hide: {
    display: 'none'
  },
  show: {
    display: 'block'
  }
};
var subscribers = [];

var emitNotification = function emitNotification() {
  subscribers.forEach(function (fn) {
    fn();
  });
};

var show = function show() {
  emitNotification();
};

var SimpleModal = function (_React$Component) {
  _inherits(SimpleModal, _React$Component);

  function SimpleModal(props) {
    _classCallCheck(this, SimpleModal);

    var _this = _possibleConstructorReturn(this, (SimpleModal.__proto__ || Object.getPrototypeOf(SimpleModal)).call(this, props));

    _this.state = {
      display: _this.props.demonstration ? 'show' : 'hide'
    };
    _this.hideModal = _this.hideModal.bind(_this);
    _this.showModal = _this.showModal.bind(_this);
    return _this;
  }

  _createClass(SimpleModal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      subscribers.push(this.showModal);
    }
  }, {
    key: 'showModal',
    value: function showModal() {
      this.setState({
        display: 'show'
      });
    }
  }, {
    key: 'hideModal',
    value: function hideModal() {
      this.setState({
        display: 'hide'
      });
    }
  }, {
    key: 'dimension',
    value: function dimension() {
      return {
        width: this.props.width || '70%',
        height: this.props.height || 'auto',
        '@media (max-width: 767px)': {
          width: this.props.mobileWidth || '80%'
        }
      };
    }
  }, {
    key: 'handleModalClick',
    value: function handleModalClick(e) {
      e.stopPropagation();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2["default"].createElement('div', {
        onClick: this.hideModal,
        style: [styles.wrapper, styles[this.state.display]]
      }, _react2["default"].createElement('div', {
        onClick: this.handleModalClick,
        style: [styles.container, this.dimension()]
      }, _react2["default"].createElement('div', {
        style: styles.btn,
        onClick: this.hideModal
      }), this.props.children));
    }
  }]);

  return SimpleModal;
}(_react2["default"].Component);

;
var component = (0, _radium2["default"])(SimpleModal);
exports["default"] = {
  component: component,
  show: show
};